import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

export const Route = createFileRoute('/(main)/suppliers/$supplierId')({
  component: Outlet,
});

export const SUPPLIER = buildRouteExport({ Route });
